import { render } from "./Footer.vue?vue&type=template&id=c343a562"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=c343a562&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/footer/Footer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c343a562"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c343a562', __exports__)) {
    api.reload('c343a562', __exports__)
  }
  
  module.hot.accept("./Footer.vue?vue&type=template&id=c343a562", () => {
    api.rerender('c343a562', render)
  })

}


export default __exports__